import React from "react";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { ToolButton } from "../../../../components";
import { IToolButtonProps } from "../../../../interfaces";

export default function EditButton({ config }: IToolButtonProps) {
  return <ToolButton text="Edit" icon={faEdit} path="?mode=edit" />;
}
